<div class="listbox-options">
  <lx-list-box
    [options]="schoolDurations"
    [(ngModel)]="selectedDuration"
    (ngModelChange)="triggerSelectedDurationChanged()"
    data-qa="duration__list"
    lxListboxScrollToSelectedItem
    [scrollWhenVisible]="dialogVisible"
  >
    <ng-template #customItemTemplate let-week pTemplate="item">
      {{ week | lxLocalizeAndPluralizePeriod }}
    </ng-template>
  </lx-list-box>
</div>
